import script from "./esPatientActionMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./esPatientActionMenu.vue?vue&type=script&setup=true&lang=ts"

import "./esPatientActionMenu.vue?vue&type=style&index=0&id=199d8832&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-199d8832"]])

export default __exports__